import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from './services/auth.service';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import * as moment from 'moment';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  scrollbarOptions = { axis: 'y', theme: 'inset-dark' };
  title = 'app';
  result = '';
  hasFilter = false;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private router: Router
  ) {
    console.log('[AppComponent] Constructor started');
    router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe((event) => {
        if (this.router.url.indexOf('/admin/login') !== 0
          && this.router.url.indexOf('/login') !== 0
          && this.router.url.indexOf('/logout') !== 0
          && this.authService.isRefreshTokenRequired()) {
          this.authService.refreshToken();
        }

        if (this.router.url.indexOf('/list') === -1
          && this.router.url.indexOf('/map') === -1
          && this.router.url.indexOf('/mapJourney') === -1
          && this.router.url.indexOf('/planning-and-optimization/synthesis') === -1
          && this.router.url.indexOf('/planning-and-optimization/journey') === -1
          && this.router.url.indexOf('/planning-and-optimization/assignments') === -1
           && this.router.url.indexOf('/planning-and-optimization/zones') === -1
          && this.router.url.indexOf('/dashboard/dashboard-pro') === -1
          && this.router.url.indexOf('/dashboard/dashboard-essentiel') === -1
          && this.router.url.indexOf('/dashboard/dashboard-geo') === -1
          && this.router.url.indexOf('/passenger-subscription') === -1
          && this.router.url.indexOf('/generalActivityReport') === -1
          && this.router.url.indexOf('/journeyActivityReport') === -1
          && this.router.url.indexOf('/detailsActivityReport') === -1
          && this.router.url.indexOf('/fuelControl') === -1
          && this.router.url.indexOf('/archive') === -1
          && this.router.url.indexOf('/depenses/depenses-edition') === -1 
          && this.router.url.indexOf('/depenses/depenses-statistics') === -1 
          && this.router.url.indexOf('/subscription/subscription-list') === -1
          && this.router.url.indexOf('/push/list') === -1
        ) {
          this.hasFilter = false;
        } else {
          this.hasFilter = true;
        }
      });
  }

  ping() {
    this.http.get('/api/client').subscribe((clients: any) => {
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn === true;
  }

  testGet() {
    this.http.get('/api/test').subscribe((res: any) => {
      this.result = res;
      console.log('test get method !! res=', res);
    });
  }

  get user(): any {
    return JSON.parse(localStorage.getItem('user'));
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts